/*!
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import svgCalendarRangeOutline from '@mdi/svg/svg/calendar-range-outline.svg?raw';
import { FileListFilter, registerFileListFilter } from '@nextcloud/files';
import { t } from '@nextcloud/l10n';
import wrap from '@vue/web-component-wrapper';
import Vue from 'vue';
import FileListFilterModified from '../components/FileListFilter/FileListFilterModified.vue';
const tagName = 'files-file-list-filter-modified';
class ModifiedFilter extends FileListFilter {
    currentInstance;
    currentPreset;
    displayName = t('files', 'Modified');
    iconSvgInline = svgCalendarRangeOutline;
    tagName = tagName;
    constructor() {
        super('files:modified', 50);
    }
    filter(nodes) {
        if (!this.currentPreset) {
            return nodes;
        }
        return nodes.filter((node) => node.mtime === undefined || this.currentPreset.filter(node.mtime.getTime()));
    }
    reset() {
        this.dispatchEvent(new CustomEvent('reset'));
    }
    get preset() {
        return this.currentPreset;
    }
    setPreset(preset) {
        this.currentPreset = preset;
        this.filterUpdated();
        const chips = [];
        if (preset) {
            chips.push({
                icon: svgCalendarRangeOutline,
                text: preset.label,
                onclick: () => this.reset(),
            });
        }
        else {
            this.currentInstance?.resetFilter();
        }
        this.updateChips(chips);
    }
}
/**
 * Register the file list filter by modification date
 */
export function registerModifiedFilter() {
    const WrappedComponent = wrap(Vue, FileListFilterModified);
    // In Vue 2, wrap doesn't support disabling shadow :(
    // Disable with a hack
    Object.defineProperty(WrappedComponent.prototype, 'attachShadow', {
        value() {
            return this;
        },
    });
    Object.defineProperty(WrappedComponent.prototype, 'shadowRoot', {
        get() {
            return this;
        },
    });
    customElements.define(tagName, WrappedComponent);
    registerFileListFilter(new ModifiedFilter());
}
